import React, { lazy } from 'react';
import { IndexRoute, Route } from 'react-router';
import PermissionsContainer from 'legacy-src/components/auth/PermissionsContainer';

const DashboardContainer = lazy(
  () => import('legacy-src/components/dashboard/DashboardContainer'),
);
const PerformanceReports = lazy(
  () => import('legacy-src/components/dashboard/PerformanceReports'),
);

export default (
  <Route
    name="dashboard"
    path="dashboard"
    component={PermissionsContainer(DashboardContainer)}
  >
    <IndexRoute component={PerformanceReports} />
    <Route path="summary" component={PerformanceReports} />
  </Route>
);
